import { cn } from '@/lib/utils'

interface StateOutOfServiceLabelProps {
  /** `standalone` renders "OUT OF SERVICE" on its own line; `inline` renders "(OUT OF SERVICE)" for use next to a value like USDOT. */
  variant?: 'standalone' | 'inline'
  className?: string
}

export function StateOutOfServiceLabel({
  variant = 'standalone',
  className,
}: StateOutOfServiceLabelProps) {
  return (
    <span className={cn('text-destructive font-bold', className)}>
      {variant === 'inline' ? '(STATE OUT OF SERVICE)' : 'STATE OUT OF SERVICE'}
    </span>
  )
}
